import angular from 'angular';
import serviceOrdersComponent from './service-orders.component';
import serviceOrdersService from './service-orders.service';
import serviceOrdersConfig from './service-orders.config';

let serviceOrdersModule = angular.module('app.serviceOrders',[])
  .component('serviceOrders', serviceOrdersComponent)
  .service('ServiceOrdersService', serviceOrdersService)
  .config(serviceOrdersConfig);

export default serviceOrdersModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/payments-advances/service-orders/service-orders.js
 **/